import {ReactComponent as Icon} from "./speechBubble.svg"

type StopwatchIconProps = {
	className?: string;
};

const SpeechBubbleIcon: React.FunctionComponent<StopwatchIconProps> = ({className}) => {
	return <Icon className={className}/>;
};

export default SpeechBubbleIcon;